import { Injectable } from '@angular/core';
import { AppActions } from '@app/app-actions.enum';
import { AssetSummaryRepository } from '@features/assets/asset-summary-repository';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { flatMap, map } from 'rxjs/operators';
import { loadSummarySuccess } from './actions';

@Injectable()
export class AssetSummaryEffects {
  constructor(
    private actions: Actions,
    private summaryRepository: AssetSummaryRepository,
  ) {}

  loadSummary$ = createEffect(() => this.actions.pipe(
    ofType(AppActions.LOAD_STATE_SUCCESS),
    flatMap(() => this.summaryRepository.current()),
    map((summary) => loadSummarySuccess({ summary })),
  ));
}
